import { LAYOUTS, IMAGE_COUNTS, roomTiles, pct } from "@/lib/layouts";

export function LayoutThumb({ layout, count, active }) {
  const tiles = roomTiles(layout, count);
  const textBox = layout === "grid" ? { left: "4%", top: "6%", width: "40%", height: "18%" }
    : layout === "editorial" ? { left: "4%", top: "36%", width: "38%", height: "54%", background: "#F5F5F0" }
    : { left: "6%", top: "16%", width: "30%", height: "60%" };
  return (
    <div className={`relative aspect-[16/9] w-full overflow-hidden border transition-colors ${active ? "border-black bg-white" : "border-stone-200 bg-stone-50"}`}>
      {tiles.map((t, i) => <div key={i} className="absolute" style={{ ...pct(t), background: i === 0 ? "#B9AE9E" : "#D9D2C7" }} />)}
      <div className="absolute flex flex-col gap-[6%] p-[2%]" style={textBox}>
        <div className="h-[10%] w-[35%] bg-stone-400" />
        <div className="h-[16%] w-[80%] bg-stone-800" />
        <div className="h-[6%] w-[90%] bg-stone-300" />
        <div className="h-[6%] w-[70%] bg-stone-300" />
      </div>
    </div>
  );
}

export function LayoutPicker({ index, layout, count, onChange }) {
  return (
    <div data-testid={`layout-picker-${index}`}>
      <div className="eyebrow mb-2">Slide layout — pick one of three</div>
      <div className="grid grid-cols-3 gap-3 mb-4">
        {LAYOUTS.map(l => (
          <button key={l.id} type="button" onClick={() => onChange({ layout: l.id })} data-testid={`layout-${index}-${l.id}`}
            className={`text-left group ${layout === l.id ? "" : "opacity-80 hover:opacity-100"}`} aria-pressed={layout === l.id}>
            <LayoutThumb layout={l.id} count={count} active={layout === l.id} />
            <div className={`mt-2 text-xs ${layout === l.id ? "text-black font-medium" : "text-stone-500"}`}>{l.name}</div>
            <div className="text-[11px] text-stone-400 leading-snug">{l.blurb}</div>
          </button>
        ))}
      </div>
      <div className="eyebrow mb-2">Images on this slide</div>
      <div className="flex gap-1" data-testid={`image-count-${index}`}>
        {IMAGE_COUNTS.map(n => (
          <button key={n} type="button" onClick={() => onChange({ image_count: n })} data-testid={`image-count-${index}-${n}`}
            className={`w-9 h-9 text-sm border ${count === n ? "bg-black text-white border-black" : "border-stone-300 hover:border-black"}`}>{n}</button>
        ))}
      </div>
    </div>
  );
}
